// extracted by mini-css-extract-plugin
module.exports = {"uikit-mrkdwn":"uikit-mrkdwn__3YVwY"};